import {
  DialogType,
  FocusTrapZone,
  IDialogContentProps,
  IModalProps,
  Layer,
  Overlay, Spinner, Stack, useTheme
} from "@fluentui/react";
import React, { CSSProperties } from "react";
import { connect } from 'react-redux';

interface IPageLoadingProperties {
  isLoading?: boolean;
  message?: string
}

const PageLoading: React.FunctionComponent<IPageLoadingProperties> = (props) => {
  const theme = useTheme();

  const overlay: CSSProperties = {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: theme.semanticColors.buttonBackground,
    opacity: '0.9',
    zIndex: 1000001
  }

  const overlayItem: CSSProperties = {
    position: "absolute",
    top: "50%",
    left: "50%",
    color: "white",
    transform: "translate(-50%, -50%)",
    msTransform: "translate(-50%, -50%)"
  }
  const modalPropsStyles = { main: { maxWidth: 450 } };
  // todo switch with fluent ui proper overlay to lock down all inputs: tab/control/mouse scroll
  const modalProps: IModalProps = {
    isBlocking: true,
    styles: modalPropsStyles,
  };

  const dialogContentProps: IDialogContentProps = {
    type: DialogType.normal,
    title: '',
    subText: '',
    showCloseButton: false
  };

  // const spinnerStyles = {
  //   circle: {
  //     height: 40,
  //     width: 40,
  //     borderWidth: 4
  //   }
  // }

  const overlayContent: CSSProperties = {
    position: 'absolute',
    textAlign: 'center',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  }

  return <Layer>
    <Overlay
      styles={{ root: { backgroundColor: 'rgba(255, 255, 255, 0.7)', width: '100%', height: '100%' } }}
      hidden={false}
    >
      <FocusTrapZone disabled={false} >
        <div style={overlayContent}>

          <Stack tokens={{ childrenGap: '18px' }} horizontalAlign='center'>
            <Spinner label={props.message} ariaLive="assertive" labelPosition="bottom" />
          </Stack>
        </div>
      </FocusTrapZone>
    </Overlay>;
  </Layer>

};

function mapStateToProps(state: any) {
  return { status: state.status }
}

export default connect(mapStateToProps)(PageLoading);

